import PropTypes from 'prop-types';
import classNames from 'classnames';

import { theme } from '@prose-ui';
import { legacyTheme } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';

import { Typography } from './Typography';

const styles = {
  list: {
    columnWidth: 240,
    paddingLeft: 0,
    width: '100%',
    listStyle: 'none',
    [legacyTheme.breakpoints.match('md')]: {
      columnWidth: 200,
    },
    [legacyTheme.breakpoints.up('md')]: {
      columnWidth: 170,
    },
    '& li': {
      ...legacyTheme.typography.p1,
      lineHeight: '16px',
      marginBottom: 16,
    },
  },
  span2: {
    display: 'block',
    color: theme.colors.neutral[700],
  },
};
const ListItems = ({ classes, data, listName, showAsterisk }) => {
  return (
    <>
      <Typography align="left" upperCase variant="p1">
        {listName}
      </Typography>
      <ul className={classes.list}>
        {data.map((d, i) => {
          return (
            <li key={`list-item-${i}`}>
              {d.map((d, i) => {
                return (
                  <span
                    key={`span-item-${i}`}
                    className={classNames(classes.span, { [classes.span2]: i === 1 })}
                  >
                    {d}
                  </span>
                );
              })}
            </li>
          );
        })}
      </ul>
      {showAsterisk && (
        <Typography align="left" variant="p3">
          * We are working hard to remove these ingredients from our formulas
        </Typography>
      )}
    </>
  );
};

ListItems.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  listName: PropTypes.string,
  showAsterisk: PropTypes.bool,
};
export default withStyles(ListItems, styles);
